import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class MachineMaintenanceService {
  private api = inject(ApiService);

  get() { return this.api.get('/machine_maintenance'); }
}
